import { action } from '@play-co/replicant';
import createActions from '../config/actions/createActions';
import { RescueLevelResult } from './rescueLevel.ruleset';
import { rescueLevelComplete } from './rescueLevel.modifiers';
import { grantMatch2Rewards } from '../match2/match2.modifiers';
import { rescueLevelGetActive } from './rescueLevel.getters';

export const rescueLevelActions = createActions({
  rescueLevelComplete: action(
    (state, args: { result: RescueLevelResult }, api) => {
      // Find the current active rescue level
      const active = rescueLevelGetActive(state);
      if (!active) return;

      // Complete the active rescue level, do nothing if failed
      const completed = rescueLevelComplete(state);
      if (!completed) return;

      // Grant rewards only if the rescue level was won
      if (args.result === 'win') {
        grantMatch2Rewards(
          state,
          [active.reward],
          {
            feature: 'rescue_level',
            $subFeature: 'rescue_level_win',
          },
          api,
        );
      }
    },
  ),
});
